import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// Models.
import { AuthInfo, AuthReq } from '../models/authObjects';

// Tikis.
import { Api } from '../common/constants/api';
import { ServerResponse } from '../models/RES/serverResponse';
import { NewRelativePerson } from '../models/REQ/newRelativePerson';
import { NewEmploymentHistory } from '../models/REQ/newEmploymentHistory';

@Injectable({
    providedIn: 'root'
})
export class EmploymentHistoryByPersonsService {
  constructor(
    private _http: HttpClient
  ) {}

  url: string = Api.EmploymentHistoryByPersons;
  jsonHeaders = { headers: { 'Content-Type': 'application/json' } }

  public GetAll(): Observable<ServerResponse> {
    return this._http.get<ServerResponse>(`${this.url}/GetAll`);
  }

  public GetEmploymentHistoryByPerson(dataId: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/GetEmploymentHistoryByPerson`, dataId, this.jsonHeaders);
  }

  public Create(data: NewEmploymentHistory): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/Create`, data);
  }

  public Edit(data: NewEmploymentHistory): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/Edit`, data);
  }

  public Disable(data: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/Disable`, data);
  }
}